module.exports = __webpack_public_path__ + "img/nita.439c8a9a.png";